import React from "react";
import { L10n } from "@fidget/common/i18n";
import { CloserLoaderComponent } from "@fidget/common/components/loader/closerLoader";
import { BeforeLoginSection } from "../components/beforeLoginSection";
import styles from "./loginOidcResponse.css";

export const LoginAuthorizingLoaderSection = () => {
  return (
    <BeforeLoginSection styleType="login">
      <div className={styles["header-font"]}>
        <L10n id="oidc.authorizing" />
      </div>
      <CloserLoaderComponent />
    </BeforeLoginSection>
  );
};
